import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { ActiveConsumers } from "ui/organizms/Consumers";

const ActiveConsumersScreen = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Consumers | Active'
    >
        <ActiveConsumers />
    </Screen>
);

export default memo(ActiveConsumersScreen);
